export default __webpack_public_path__ + "static/media/Deacon's Bracers of the Abyss.c086a759.jpg";